module.exports = __webpack_public_path__ + "media/images/sp/components/store/no_image-8a25cd14563dd61d8b35f39c91c78cd0.jpg";